<template>
  <div
    class="border-blue-500 border-l-2 p-12 mt-16 gap-12 flex-row flex bg-grey-100"
  >
    <Icon
      iconClass="fas fa-exclamation-circle"
      class="text-xl text-blue-500 self-center"
    />
    <div
      v-if="enrollmentEmail"
      class="grid grid-cols-6 gap-4 items-center pl-10"
    >
      <p class="text-sm col-span-5">
        {{ $t('rewards.verification.warning') }}
      </p>
      <router-link
        class="text-blue-500 underline col-span-1 text-center"
        :to="{ name: 'rewards-email-verification' }"
      >
        {{ $t('rewards.verification.verify_email') }}
      </router-link>
    </div>
    <div v-else class="grid grid-cols-6 gap-4 items-center pl-10">
      <p class="text-sm col-span-5">
        {{
          `The email address that you entered does not exist for your account. You'll need to contact your plan and provide them with your email. Once your email has been verified, you can get digital rewards.`
        }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('member', ['enrollmentEmail']),
  },
}
</script>
